// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"230":"confirmation","231":"checkout","690":"items"}[chunkId] + "." + {"230":"57c73a18","231":"895fdea3","690":"895fdea3"}[chunkId] + ".css";
};